import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from "./app/owl-carousel.js";
import SlickSlider from "./app/slick-slider";
import modaal from 'modaal';
import modal from './app/modal.js';
import GsapAnimation from "./app/gsap";
import anime from 'animejs';
import modaalCss from 'modaal/dist/css/modaal.css';

import Sticky from "sticky-js";
import CustomFunctions from "./app/custom";
class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
    this.gsap = new GsapAnimation();
    this.defaultOptions = {
      gsap: this.gsap,
      utils: this.Utils
    }
    // 上記のオプション以外で必要な要素は追加する。
    new OwlCarousel({...this.defaultOptions});
    new SlickSlider({...this.defaultOptions});
    new CustomFunctions({...this.defaultOptions});

    $(function () {
      var win = $(window).innerWidth();
      if (win > 750) {
        if ($(".c-menu-list").length > 0) {
          var sticky = new Sticky('.c-menu-list');
        }
        if ($(".c-block-service-front__head").length > 0) {
          var sticky = new Sticky('.c-block-service-front__head');
        }
      }
    })
  }
}

window.GApp = new App();
